import React from 'react';

import { useGetPermissionTags } from '@vlabs/api/artemy/client';
import { PaginationPanel } from '@vlabs/uikit/components/pagination-v2';
import { useTranslation } from 'react-i18next';

import { PermissionTagListFastFilters, usePermissionTagsFilters } from '@vlabs/monokit/entities/permission-tags/filters/';

import { SortPermissionTagsDropdown } from '@vlabs/monokit/entities/permission-tags';

import { PermissionTagListTable } from './permission-tag-list-table/PermissionTagListTable';
import st from './PermissionTagListTableViewer.module.sass';

function PermissionTagListTableViewer(): React.JSX.Element {
  const { t } = useTranslation();
  const { filters, updateFilters } = usePermissionTagsFilters();
  const getPermissionTags = useGetPermissionTags(filters);
  const page = filters.page ?? 1;
  const pageSize = filters.page_size ?? 25;
  const permissionTags = getPermissionTags.data?.permission_tags ?? [];
  const canNextPage = permissionTags.length >= pageSize;
  let pageCount = page;
  if (canNextPage) pageCount += 1;

  return (
    <React.Fragment>
      <div className={st.Others}>
        <div className={st.CountAndFilters}>
          <span>
            {t(
              'widgets:permission_tag_list_table_viewer.tags_count',
              { count: permissionTags.length },
            )}
          </span>
          <PermissionTagListFastFilters />
        </div>
        <SortPermissionTagsDropdown />
      </div>
      <div className={st.DataContainer}>
        <PermissionTagListTable data={permissionTags} />
      </div>
      <div className={st.Pagination}>
        <PaginationPanel
          canNextPage={canNextPage}
          canPreviousPage={page > 1}
          gotoPage={(pageIndex) => updateFilters({ page: pageIndex + 1 })}
          nextPage={() => updateFilters({ page: page + 1 })}
          pageCount={pageCount}
          pageIndex={page - 1}
          pageSize={pageSize}
          previousPage={() => updateFilters({ page: page - 1 })}
          setPageSize={(page_size: number) => updateFilters({ page: 1, page_size })}
        />
      </div>
    </React.Fragment>
  );
}

export { PermissionTagListTableViewer };
